<template>
  <div>
    <div class="breadcrumbs-class">
      <Breadcrumb></Breadcrumb>
    </div>
    <div class="info-class my-5">
      <div>
        <img :src="videoInfo.vodPic" class="video-info-background" alt=""/>
      </div>
      <div class="container-class mb-3">
        <v-container>
          <v-row justify="center">
            <v-col lg="8" cols="12">
              <v-container>
                <v-row justify="center">
                  <v-col cols="6" lg="4">
                    <v-card max-width="250" max-height="350" class="mx-auto">
                      <v-img :src="videoInfo.vodPic" max-height="350" :lazy-src="lazyImg"
                             class="rounded white--text align-end"
                             gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
                        <v-card-title>
                          <div class="text-subtitle-2 text-no-wrap text-truncate">
                            {{ videoInfo.vodRemarks }}
                          </div>
                        </v-card-title>
                      </v-img>
                    </v-card>
                  </v-col>
                  <v-col cols="6" lg="8">
                    <div class="white--text text-info-class">
                      <div class="text-subtitle-1 align-center text-no-wrap text-truncate">
                        {{ videoInfo.vodName }}
                      </div>
                      <div class="d-flex rating-class">
                        <div>
                          <v-rating
                              half-increments
                              v-model="videoInfo.vodDoubanScore"
                              background-color="#f90"
                              color="#f90"
                              readonly
                              dense
                          ></v-rating>
                        </div>
                        <div class="ml-1">
                      <span class="text--lighten-2  rating-text-class">
                        {{ videoInfo.vodDoubanScore }}分
                      </span>
                        </div>
                      </div>
                      <!--                  <div v-for="(detail,index) in describe" :key="index"-->
                      <!--                       class="text-no-wrap text-truncate">-->
                      <!--                    {{ detail.muted }} {{ detail.join }}-->
                      <!--                  </div>-->

                      <div class="text-no-wrap text-truncate">
                        分类：{{ videoInfo.typeName }}
                      </div>
                      <div class="text-no-wrap text-truncate">
                        年份：{{ videoInfo.vodYear }}
                      </div>
                      <div class="text-no-wrap text-truncate">
                        地区：{{ videoInfo.vodArea }}
                      </div>
                      <div class="text-no-wrap text-truncate">
                        主演：{{ videoInfo.vodActor }}
                      </div>
                      <div class="text-no-wrap text-truncate">
                        导演：{{ videoInfo.vodDirector }}
                      </div>


                      <div class="d-none d-sm-flex and-up" v-html="videoInfo.vodContent">
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>

            <v-col lg="4" cols="12">
              <div>
                <v-card height="350">
                  <v-card-title>
                    <v-tabs v-model="tab" @change="getSelection">
                      <v-tab v-for="(item,index) in episodes" :key="index">{{ item.classifyName }}</v-tab>
                    </v-tabs>
                  </v-card-title>
                  <v-divider></v-divider>
                  <div class="d-flex justify-space-between selections-class px-5 pt-3">
                    <div class="pa-1">
                      <v-select
                          v-model="selected"
                          :items="selections"
                          item-text="name"
                          item-value="index"
                          label="Select"
                          dense
                          solo
                      ></v-select>
                    </div>
                    <div class="pa-1">
                      <v-btn
                          height="38"
                          @click="sortSelections"
                      >
                        <v-icon dark v-if="sort">
                          mdi-sort-ascending
                        </v-icon>
                        <v-icon dark v-else>
                          mdi-sort-descending
                        </v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <v-divider></v-divider>
                  <v-card-text>
                    <div v-if="selections.length !== 0">
                      <v-virtual-scroll
                          :bench="benched"
                          :items="selections[selected].list"
                          height="160"
                          item-height="50"
                      >
                        <template v-slot:default="{ item, index }">
                          <div :key="index" class="pa-3">
                            <v-btn block @click="toPlay(item)">
                              {{ item.name }}
                            </v-btn>
                          </div>
                        </template>
                      </v-virtual-scroll>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>

    </div>

    <!--    <div>-->
    <!--      <v-card>-->
    <!--        <v-card-title>-->
    <!--          <div class="text-h5">猜你喜欢</div>-->
    <!--        </v-card-title>-->
    <!--        <v-divider></v-divider>-->
    <!--        <v-card-text>-->
    <!--          <video-list :list="likeList"></video-list>-->
    <!--        </v-card-text>-->
    <!--      </v-card>-->
    <!--    </div>-->
  </div>
</template>

<script>
import {info} from '@/api/resources/video'
import {mapMutations, mapGetters} from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import {splitUrl} from "@/utils/filters";
import base64 from "@/utils/base64";

export default {
  data: () => ({
    benched: 0,
    vid: undefined,
    videoInfo: {},
    selected: 0,
    tab: 0,
    describe: [],
    likeList: [],
    episodes: [],
    selections: [],
    reversedList: [],
    sortList: [],
    sort: false,
    lazyImg: require('@/assets/img-loading.gif'),
  }),
  created() {
    this.vid = this.$route.query.id
    this.init(this.vid);
  },
  computed: {
    ...mapGetters(['getNode']),
    isModel() {
      return this.$vuetify.breakpoint.name === 'xs';
    },

  },
  components: {
    Breadcrumb
  },
  methods: {
    ...mapMutations(['setLoading', 'clearLoading']),
    init(vid) {
      this.setLoading()
      info(vid).then(req => {

        let {
          vodContent,
          // describe,
          vodPic,
          vodDoubanScore,
          vodRemarks,
          vodName,
          typeName,
          vodYear,
          vodArea,
          vodActor,
          vodDirector,
          episodes
        } = req.data.data

        vodDoubanScore = (vodDoubanScore * 1) / 2

        this.videoInfo = {
          vodContent,
          vodPic,
          vodDoubanScore,
          vodRemarks,
          vodName,
          typeName,
          vodYear,
          vodArea,
          vodActor,
          vodDirector
        }

        this.episodes = episodes;

        // this.describe = describe;
        this.selections = splitUrl(episodes[0].episodes)
        // this.likeList = likeList;

      }).finally(() => {
        this.clearLoading()
      })
    },
    toInfo({id}) {
      this.$router.push({
        path: '/video/info',
        query: {id: id}
      })
    },
    toPlay(item) {
      this.$router.push({
        path: '/video/player',
        query: {eid: new base64().encode(JSON.stringify(item)), vid: this.vid}
      })
    },
    getSelection(e) {
      let item = this.episodes[e]
      this.selections = splitUrl(item.episodes);
    },

    sortSelections() {
      this.sort = !this.sort;
      this.selections.forEach((item) => {
        let {list} = item
        item.list = list.reverse()
      })
    },

    //冒泡排序
    // bubbleSort(list) {
    //   for (let i = 0; i < list.length - 1; i++) {
    //     for (let j = 0; j < list.length - i - 1; j++) {
    //       if (list[j] > list[j + 1]) {
    //         //  借用数组解构赋值
    //         [list[j], list[j + 1]] = [list[j + 1], list[j]];
    //       }
    //     }
    //   }
    //   return list;
    // },
  }
}
</script>

<style scoped>
.video-info-background {
  height: 100%;
  width: 100%;
  top: 0;
  position: absolute;
  left: 0;
  filter: blur(30px) brightness(60%);
}

.selections-class {
  width: 100%;
}

.info-class {
  position: relative;
}

.rating-class {
  line-height: 28px;
}

.rating-text-class {
  font-size: 16px;
  color: #f90;
}

.text-info-class > div {
  margin: 5px;
}

.container-class {
  position: relative;
}
</style>
